import type {SearchRequest} from '@api';

export const availableFiltersTypes = [
    'actions',
    'freelancers',
    'owners',
    'companies',
    'organizations',
    'status',
    'companyManagers',
    'finOpsManagers',
    'customerSuccessManagers',
    'contractTypes',
    'verticalTypes',
    'opportunityTypes',
    'startDateFrom',
    'startDateTo',
    'endDateFrom',
    'endDateTo',
    'renewalStatuses',
] as const;

export type AvailableSearchFilterType = typeof availableFiltersTypes;
export type AvailableSearchFilters = Pick<SearchRequest, (typeof availableFiltersTypes)[number]>;
export type AvailableAggregations = keyof AvailableSearchFilters;
